export default __webpack_public_path__ + "14eb562062f5b097107fbb8fa7baccbb.png";